import { isEmpty } from 'lodash'
import { StreamData } from 'types/streamData'
import { FieldResolver } from './fieldResolver'
import { Metadata } from '../adaptor/metadata'

const postRatingResolver: FieldResolver = (metadata: Metadata) =>
  ({
    postRating: !isEmpty(metadata.getPostRating()) ? metadata.getPostRating() : undefined
  } as StreamData)

export default postRatingResolver
